<template>
  <button class="btn btn--primary" type="submit" @click="$emit('submit')">{{text}}</button>
</template>

<script>
export default {
	name: 'Submit',
	props: {
		text: String,
	}
}
</script>